import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import $ from 'jquery';
import PropTypes from 'prop-types';
import * as accountActions from '../../../actions/accountActions';

class CookieDetails extends React.Component {
  componentDidMount() {
    // this.props.accountActions.getUserConfiguration();
    $('#smartLoader')
      .removeClass('active')
      .removeClass('opaque');
    $('#smartLoader-loader').removeClass('active');
  }

  render() {
    return (
      <div className="cookies-info-container">
        <h1>Aviso de cookies</h1>
        <p>
          Las cookies son pequeños archivos que almacenan información en el equipo del usuario para recordar datos o
          preferencias de navegación. Se trata de una herramienta habitual y son esenciales para el funcionamiento de
          Internet, aportando innumerables ventajas en la prestación de servicios interactivos que NETEX KNOWLEDGE
          FACTORY S.A. utiliza, como por ejemplo el análisis del uso de este Sitio web con el objetivo de mejorar su
          eficacia y usabilidad. Estos archivos contribuyen también a agilizar la navegación.
        </p>
        <p>La plataforma {this.props.platformName} utiliza los siguientes tipos de cookies</p>
        <ul>
          <li>
            <b>Cookies técnicas:</b> Son aquellas que permiten al usuario la navegación a través del área restringida y
            la utilización de sus diferentes funciones, como por ejemplo, realizar el seguimiento de los alumnos en los
            cursos.
          </li>
          <li>
            <b>Cookies de análisis:</b> Son aquéllas que bien tratadas por nosotros o por terceros, nos permiten
            cuantificar el número de usuarios y así realizar la medición y análisis estadístico de la utilización que
            hacen los usuarios del servicio ofertado. Para ello se analiza su navegación en nuestra página web con el
            fin de mejorar la oferta de productos o servicios que le ofrecemos.
          </li>
          <li>
            <b>Cookies de personalización:</b> Son aquéllas que permiten al usuario acceder al servicio con algunas
            características de carácter general predefinidas en función de una serie de criterios en el terminal del
            usuario como por ejemplo serían el idioma o el tipo de navegador a través del cual se conecta al servicio.
          </li>
        </ul>
        <p>
          Recuerde que ciertas funciones y la plena funcionalidad de este Sitio pueden no estar disponibles después de
          deshabilitar los cookies.
        </p>
        <p>
          Puede usted permitir, bloquear o eliminar las cookies instaladas en su equipo mediante la configuración de las
          opciones del navegador instalado en su ordenador.
        </p>
        <table>
          <tbody>
            <tr>
              <td>Firefox</td>
              <td>
                <a
                  href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-que-los-sitios-we"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-que-los-sitios-we
                </a>
              </td>
            </tr>
            <tr>
              <td>Chrome</td>
              <td>
                <a
                  href="https://support.google.com/chrome/bin/answer.py?hl=es&answer=95647"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  https://support.google.com/chrome/bin/answer.py?hl=es&answer=95647
                </a>
              </td>
            </tr>
            <tr>
              <td>Explorer</td>
              <td>
                <a
                  href="https://windows.microsoft.com/es-es/internet-explorer/delete-manage-cookies#ie=ie-10"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  https://windows.microsoft.com/es-es/internet-explorer/delete-manage-cookies#ie=ie-10
                </a>
              </td>
            </tr>
            <tr>
              <td>Safari</td>
              <td>
                <a href="https://support.apple.com/kb/ph5042" rel="noopener noreferrer" target="_blank">
                  https://support.apple.com/kb/ph5042
                </a>
              </td>
            </tr>
            <tr>
              <td>Opera</td>
              <td>
                <a
                  href="https://help.opera.com/Windows/11.50/es-ES/cookies.html"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  https://help.opera.com/Windows/11.50/es-ES/cookies.html
                </a>
              </td>
            </tr>
          </tbody>
        </table>
        <h2>Tabla de cookies</h2>
        <h3 id="propias">Propias</h3>
        <table>
          <thead>
            <tr>
              <th>Cookie</th>
              <th>Descripción</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>SESSION</td>
              <td>Mantiene la sesión del usuario</td>
            </tr>
            <tr>
              <td>CookieConsent</td>
              <td>Gestión de política de cookies</td>
            </tr>
            <tr>
              <td>analyticsConsent</td>
              <td>Gestión de política de cookies de analítica</td>
            </tr>
            <tr>
              <td>meetConsent</td>
              <td>Gestión de política de cookies de videoconferencia</td>
            </tr>
          </tbody>
        </table>
        <h3>Terceros</h3>
        <table>
          <thead>
            <tr>
              <th>Cookie</th>
              <th>Descripción</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <strong>Funcional</strong>
              </td>
              <td></td>
            </tr>
            <tr id="aws">
              <td>
                <strong>
                  <em>AWS</em>
                </strong>
              </td>
              <td></td>
            </tr>
            <tr>
              <td>CloudFront-Policy</td>
              <td>Política de acceso al recurso codificada en base64</td>
            </tr>
            <tr>
              <td>CloudFront-Signature</td>
              <td>Versión hash y firmada de la política de acceso al recurso</td>
            </tr>
            <tr>
              <td>CloudFront-Key-Pair-Id</td>
              <td>
                ID de clave pública para la clave pública de CloudFront cuya clave privada correspondiente se utiliza
                para generar la firma
              </td>
            </tr>
            <tr id="datadog">
              <td>
                <strong>
                  <em>Datadog</em>
                </strong>
              </td>
              <td></td>
            </tr>
            <tr>
              <td>_dd_s</td>
              <td>utilizada para proporcionar análisis de rendimiento web y resolución de errores</td>
            </tr>
            <tr>
              <td>
                dd_cookie<em>test</em>
              </td>
              <td>utilizada para proporcionar análisis de rendimiento web y resolución de errores</td>
            </tr>
            <tr id="youtube">
              <td>
                <strong>
                  <em>Youtube</em>
                </strong>
              </td>
              <td></td>
            </tr>
            <tr>
              <td>HSID</td>
              <td>
                contiene registros encriptados y firmados de forma digital de la hora de inicio de sesión más reciente y
                del ID de cuenta de Google de un usuario
              </td>
            </tr>
            <tr>
              <td>LOGIN_INFO</td>
              <td>para almacenar las preferencias del usuario utilizadas en la reproducción de vídeo</td>
            </tr>
            <tr>
              <td>PREF</td>
              <td>
                para almacenar información como la configuración de página o las preferencias de reproducción del
                usuario (por ejemplo, la reproducción automática, la reproducción aleatoria de contenido y el tamaño del
                reproductor). En YouTube Music, estas preferencias incluyen el volumen, el modo de repetición y la
                reproducción automática
              </td>
            </tr>
            <tr>
              <td>SID</td>
              <td>
                contiene registros encriptados y firmados de forma digital de la hora de inicio de sesión más reciente y
                del ID de cuenta de Google de un usuario
              </td>
            </tr>
            <tr>
              <td>SIDCC</td>
              <td>Cookie de seguridad para proteger los datos de un usuario del acceso no autorizado</td>
            </tr>
            <tr>
              <td>VISITOR_INFO1_LIVE</td>
              <td>
                habilita las recomendaciones personalizadas en YouTube, que están basadas en las visualizaciones y
                búsquedas que haya hecho el usuario
              </td>
            </tr>
            <tr>
              <td>YSC</td>
              <td>
                destinado al control de visitas de los videos y registro de ciertos eventos como me gusta o compartir
                video
              </td>
            </tr>
            <tr>
              <td>APISID</td>
              <td>Google advertising</td>
            </tr>
            <tr>
              <td>CONSENT</td>
              <td>Google advertising</td>
            </tr>
            <tr>
              <td>SAPISID</td>
              <td>Google advertising</td>
            </tr>
            <tr>
              <td>SSID</td>
              <td>Google advertising</td>
            </tr>
            <tr>
              <td>__Secure-3PSID</td>
              <td>Google advertising</td>
            </tr>
            <tr>
              <td>__Secure-3PAPISID</td>
              <td>Google advertising</td>
            </tr>
            <tr>
              <td>__Secure-3PSIDCC</td>
              <td>Google advertising</td>
            </tr>
            <tr id="vimeo">
              <td>
                <strong>
                  <em>Vimeo</em>
                </strong>
              </td>
              <td></td>
            </tr>
            <tr>
              <td>afUserId</td>
              <td>permite que el reproductor funcione correctamente y mejora la experiencia del usuario</td>
            </tr>
            <tr>
              <td>continuous_play_v3</td>
              <td>permite que el reproductor funcione correctamente y mejora la experiencia del usuario</td>
            </tr>
            <tr>
              <td>player</td>
              <td>permite que el reproductor funcione correctamente y mejora la experiencia del usuario</td>
            </tr>
            <tr>
              <td>sd_client_id</td>
              <td>permite que el reproductor funcione correctamente y mejora la experiencia del usuario</td>
            </tr>
            <tr>
              <td>site_settings</td>
              <td>permite que el reproductor funcione correctamente y mejora la experiencia del usuario</td>
            </tr>
            <tr>
              <td>vuid</td>
              <td>permite que el reproductor funcione correctamente y mejora la experiencia del usuario</td>
            </tr>
            <tr>
              <td>_abexps</td>
              <td>permite que el reproductor funcione correctamente y mejora la experiencia del usuario</td>
            </tr>
            <tr>
              <td>_uetvid</td>
              <td>permite que el reproductor funcione correctamente y mejora la experiencia del usuario</td>
            </tr>
            <tr>
              <td>__uetsid</td>
              <td>permite que el reproductor funcione correctamente y mejora la experiencia del usuario</td>
            </tr>
            <tr>
              <td>_ga</td>
              <td>utilizado por Google Analytics para distingir a los usuarios</td>
            </tr>
            <tr>
              <td>_gid</td>
              <td>utilizado por Google Analytics para distingir a los usuarios</td>
            </tr>
            <tr>
              <td>_gac_XXX</td>
              <td>utilizado por Google AdSense para experimentar con la eficiencia de los anuncios en sitios web</td>
            </tr>
            <tr>
              <td>_gcl_au</td>
              <td>utilizado por Google AdSense para experimentar con la eficiencia de los anuncios en sitios web</td>
            </tr>
            <tr>
              <td>_gcl_aw</td>
              <td>utilizado por Google AdSense para experimentar con la eficiencia de los anuncios en sitios web</td>
            </tr>
            <tr>
              <td>_gcl_dc</td>
              <td>utilizado por Google AdSense para experimentar con la eficiencia de los anuncios en sitios web</td>
            </tr>
            <tr id="google_sso">
              <td>
                <strong>
                  <em>Google SSO</em>
                </strong>
              </td>
              <td></td>
            </tr>
            <tr>
              <td>__Host-GAPS</td>
              <td>Cookie necesaria para la utilización de las opciones y servicios del sitio web</td>
            </tr>
            <tr>
              <td>__Host-3PLSID</td>
              <td>Cookie necesaria para la utilización de las opciones y servicios del sitio web</td>
            </tr>
            <tr>
              <td>__Host-1PLSID</td>
              <td>Cookie necesaria para la utilización de las opciones y servicios del sitio web</td>
            </tr>
            <tr>
              <td>LSID</td>
              <td>Cookie necesaria para la utilización de las opciones y servicios del sitio web</td>
            </tr>
            <tr>
              <td>ACCOUNT_CHOOSER</td>
              <td>Cookie necesaria para la utilización de las opciones y servicios del sitio web</td>
            </tr>
            <tr>
              <td>__Secure-1PAPISID</td>
              <td>Cookie necesaria para la utilización de las opciones y servicios del sitio web</td>
            </tr>
            <tr>
              <td>__Secure-1PSID</td>
              <td>Cookie necesaria para la utilización de las opciones y servicios del sitio web</td>
            </tr>
            <tr>
              <td>user_id</td>
              <td>Cookie utilizada para identificar a los usuarios y sesiones</td>
            </tr>
            <tr>
              <td>
                <strong>Analítica</strong>
              </td>
              <td></td>
            </tr>
            <tr id="gAnalytics">
              <td>
                <strong>
                  <em>Google Analytics</em>
                </strong>
              </td>
              <td></td>
            </tr>
            <tr>
              <td>_ga</td>
              <td>se usa para distinguir a los usuarios</td>
            </tr>
            <tr>
              <td>_gat_smart</td>
              <td>mantiene el estado de la sesión Google Analytics</td>
            </tr>
            <tr>
              <td>_gid</td>
              <td>se usa para distinguir a los usuarios</td>
            </tr>
            <tr>
              <td>__utma</td>
              <td>se usa para distinguir usuarios y sesiones</td>
            </tr>
            <tr>
              <td>SIDCC</td>
              <td>cookie de seguridad para proteger los datos de un usuario del acceso no autorizado</td>
            </tr>
            <tr>
              <td>SID</td>
              <td>
                contiene registros encriptados y firmados de forma digital de la hora de inicio de sesión más reciente y
                del ID de cuenta de Google de un usuario
              </td>
            </tr>
            <tr>
              <td>HSID</td>
              <td>
                contiene registros encriptados y firmados de forma digital de la hora de inicio de sesión más reciente y
                del ID de cuenta de Google de un usuario
              </td>
            </tr>
            <tr>
              <td>APISID</td>
              <td>Google advertising</td>
            </tr>
            <tr>
              <td>CONSENT</td>
              <td>Google advertising</td>
            </tr>
            <tr>
              <td>NID</td>
              <td>Google advertising</td>
            </tr>
            <tr>
              <td>SAPISID</td>
              <td>Google advertising</td>
            </tr>
            <tr>
              <td>__Secure-3PSID</td>
              <td>Google advertising</td>
            </tr>
            <tr>
              <td>__Secure-3PSIDCC</td>
              <td>Google advertising</td>
            </tr>
            <tr>
              <td>__Secure-3PAPISID</td>
              <td>Google advertising</td>
            </tr>
            <tr>
              <td>SSID</td>
              <td>Google advertising</td>
            </tr>
            <tr>
              <td>__Secure-3PSID</td>
              <td>Google advertising</td>
            </tr>
            <tr>
              <td>gstatic.com</td>
              <td>Google advertising</td>
            </tr>
            <tr id="mClarity">
              <td>
                <strong>
                  <em>Microsoft Clarity</em>
                </strong>
              </td>
              <td></td>
            </tr>
            <tr>
              <td>_clck</td>
              <td>
                Persiste el ID de usuario y las preferencias de Clarity, exclusivos de ese sitio que se atribuyen al
                mismo ID de usuario
              </td>
            </tr>
            <tr>
              <td>_clsk</td>
              <td>
                Conecta varias páginas vistas por parte de un usuario en una única grabación de sesión de Clarity.
              </td>
            </tr>
            <tr>
              <td>CLID</td>
              <td>Identifica la primera vez que Clarity vio a este usuario en cualquier sitio usando Clarity.</td>
            </tr>
            <tr>
              <td>ANONCHK</td>
              <td>
                Indica si MUID se transfiere a ANID, una cookie utilizada con fines publicitarios. Clarity no usa ANID,
                por lo que siempre se establece en 0.
              </td>
            </tr>
            <tr>
              <td>MR</td>
              <td>Indica si se debe actualizar MUID.</td>
            </tr>
            <tr>
              <td>MUID</td>
              <td>
                Identifica navegadores web únicos que visitan sitios de Microsoft. Estas cookies se utilizan con fines
                publicitarios, análisis del sitio y otros fines operativos.
              </td>
            </tr>
            <tr>
              <td>SM</td>
              <td>Se utiliza para sincronizar el MUID entre dominios de Microsoft.</td>
            </tr>
            <tr>
              <td>
                <strong>Videoconferencia</strong>
              </td>
              <td></td>
            </tr>
            <tr id="gMeet">
              <td>
                <strong>
                  <em>Google Meet</em>
                </strong>
              </td>
              <td></td>
            </tr>
            <tr>
              <td>G_AUTHUSER_H</td>
              <td>se usa para iniciar sesión con la cuenta de Google</td>
            </tr>
            <tr>
              <td>G_ENABLED_IDPS</td>
              <td>se usa para iniciar sesión con la cuenta de Google</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

CookieDetails.propTypes = {
  platformName: PropTypes.string,
  accountActions: PropTypes.object
};

function mapStateToProps(state) {
  return {
    platformName: state.account.configuration.platformName
  };
}

function mapDispatchToProps(dispatch) {
  return {
    accountActions: bindActionCreators(accountActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CookieDetails);
